<ng-container *transloco="let t">
  <div class="row col-sm-4">
    <ISelectMenu
      class="w-20"
      [value]="selectedOrganization()"
      (valueChange)="selectOrganization($event)"
      by="id"
      [popoverWidth]="400"
      [(searchQuery)]="searchQuery"
    >
      <ISelectTrigger>
        <ISelectValue [placeholder]="t('data-sharing.select_an_organization')">
          <div *iSelectValue="let org" class="flex items-center">
            <span class="mr-2 truncate text-sm">{{ org.organizationName }}</span>
            @if (org.accessLevel !== AccessLevel.ADMIN) {
              <IBadge label="{{ t('data-sharing.restricted_to_admin') }}" size="xs" color="orange" variant="soft" />
            }
            @if (org.accessLevel === AccessLevel.ADMIN && org.dataWarehouseAccess) {
              <IBadge label="{{ t('common.activated') }}" size="xs" variant="soft" />
            }
          </div>
        </ISelectValue>
      </ISelectTrigger>
      <ISelectContent>
        @for (org of filteredOrganizations(); track org.id) {
          <ISelectOption [value]="org" [disabled]="org.accessLevel !== AccessLevel.ADMIN">
            <span class="mr-2 truncate text-sm" [class.disabled]="org.accessLevel !== AccessLevel.ADMIN">{{
              org.organizationName
            }}</span>
            @if (org.accessLevel !== AccessLevel.ADMIN) {
              <IBadge label="{{ t('data-sharing.restricted_to_admin') }}" size="xs" color="orange" variant="soft" />
            }
            @if (org.accessLevel === AccessLevel.ADMIN && org.dataWarehouseAccess) {
              <IBadge label="{{ t('common.activated') }}" size="xs" variant="soft" />
            }
          </ISelectOption>
        }
      </ISelectContent>
    </ISelectMenu>
  </div>
</ng-container>
